import { useState } from "react";
import { Button, Label, ModalDelete } from "expano-components";
import { Dashboard } from "components";
import useDelete from "hooks/useDelete";

import AddChannel from "./components/AddChannel";

const ChannelProductGroups = ({
  platform_type,
  product_group_id,
  refetch,
  data,
}) => {
  const [is_open_channel_modal, setOpenChannelModal] = useState(false);
  const [channel_product_group_to_delete, setChannelProductGroupToDelete] =
    useState(null);

  const { is_deleting, _delete } = useDelete({
    path: `/channel_product_groups/${channel_product_group_to_delete?.id}`,
  });

  const handleDelete = async () => {
    await _delete();
    refetch();
    setChannelProductGroupToDelete(null);
  };

  const existing_channel_ids = data?.map(({ channel }) => channel.id);

  return (
    <Dashboard
      header={{
        icon: "channel",
        title: `Kanały ${platform_type.split("::")[0]}`,
      }}
      footer={
        <Button
          type="add"
          text="Przypisz kanał"
          onClick={() => setOpenChannelModal(true)}
        />
      }
    >
      {is_open_channel_modal && (
        <AddChannel
          platform_type={platform_type}
          existing_channel_ids={existing_channel_ids}
          product_group_id={product_group_id}
          refetch={refetch}
          handleClose={() => setOpenChannelModal(false)}
        />
      )}
      {channel_product_group_to_delete?.id && (
        <ModalDelete
          name={`przypisanie produktu grupowego do kanału ${channel_product_group_to_delete?.identifier}?`}
          handleDelete={handleDelete}
          handleClose={() => setChannelProductGroupToDelete(null)}
        />
      )}
      {data?.length > 0 && (
        <table className="table">
          <tbody className="table__body table-body">
            {data.map(({ id, is_brand_channel, channel }) => (
              <tr key={id}>
                <td>
                  <Label
                    type="double"
                    left={{
                      text: channel?.shop?.label_text,
                      color: `#${channel?.shop?.label_color}`,
                    }}
                    right={{
                      text: channel?.platform?.label_text,
                      color: `#${channel?.platform?.label_color}`,
                    }}
                  />
                  {channel?.identifier}
                  {!is_brand_channel && (
                    <span className="tag tag--danger m-l-10">Spoza marki</span>
                  )}
                </td>
                <td>
                  <Button
                    disabled={is_deleting}
                    type="delete-bin"
                    onClick={() =>
                      setChannelProductGroupToDelete({
                        id,
                        identifier: channel?.identifier,
                      })
                    }
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Dashboard>
  );
};

export default ChannelProductGroups;
